// Design token system — mirrors POS redesign tokens.js
// Three themes: light, dark, black. Same semantic keys across all three.
// Import: import { TOKENS, getTokens } from '../../utils/tokens';
// Usage:  const tk = getTokens(mode);

export const TOKENS = {
  light: {
    bg: '#f6f6f4',
    surface: '#ffffff',
    surfaceAlt: '#fafaf8',
    sunken: '#efefec',
    text: '#1a1a1f',
    textSecondary: '#5a5a66',
    textMuted: '#8a8a96',
    border: '#e7e7e3',
    borderStrong: '#d8d8d3',
    accent: '#4f46e5',
    accentHover: '#4338ca',
    accentSoft: '#eef2ff',
    accentText: '#3730a3',
    success: '#0d9488',
    successSoft: '#ccfbf1',
    successText: '#115e59',
    danger: '#dc2626',
    dangerSoft: '#fee2e2',
    dangerText: '#991b1b',
    warning: '#d97706',
    warningSoft: '#fef3c7',
    warningText: '#92400e',
    shadow: '0 1px 2px rgba(15,15,25,0.04), 0 4px 12px rgba(15,15,25,0.04)',
    shadowLg: '0 4px 12px rgba(15,15,25,0.06), 0 16px 40px rgba(15,15,25,0.08)',
    cat: ['#4f46e5','#0d9488','#d97706','#db2777','#7c3aed','#0891b2','#65a30d','#dc2626'],
  },
  dark: {
    bg: '#13141a',
    surface: '#1a1c23',
    surfaceAlt: '#22242c',
    sunken: '#0f1015',
    text: '#f0f0f5',
    textSecondary: '#a8a8b8',
    textMuted: '#6b6b7a',
    border: '#2a2c36',
    borderStrong: '#363845',
    accent: '#818cf8',
    accentHover: '#6366f1',
    accentSoft: 'rgba(129,140,248,0.12)',
    accentText: '#c7d2fe',
    success: '#2dd4bf',
    successSoft: 'rgba(45,212,191,0.12)',
    successText: '#5eead4',
    danger: '#f87171',
    dangerSoft: 'rgba(248,113,113,0.12)',
    dangerText: '#fca5a5',
    warning: '#fbbf24',
    warningSoft: 'rgba(251,191,36,0.12)',
    warningText: '#fde68a',
    shadow: '0 1px 2px rgba(0,0,0,0.3), 0 4px 12px rgba(0,0,0,0.2)',
    shadowLg: '0 4px 12px rgba(0,0,0,0.4), 0 16px 40px rgba(0,0,0,0.3)',
    cat: ['#818cf8','#2dd4bf','#fbbf24','#f472b6','#a78bfa','#22d3ee','#a3e635','#f87171'],
  },
  black: {
    bg: '#0a0a0d',
    surface: '#101015',
    surfaceAlt: '#15151c',
    sunken: '#06060a',
    text: '#f5f5fa',
    textSecondary: '#9a9aab',
    textMuted: '#5a5a6a',
    border: '#1f1f28',
    borderStrong: '#2a2a36',
    accent: '#818cf8',
    accentHover: '#a5b4fc',
    accentSoft: 'rgba(129,140,248,0.10)',
    accentText: '#c7d2fe',
    success: '#2dd4bf',
    successSoft: 'rgba(45,212,191,0.10)',
    successText: '#5eead4',
    danger: '#f87171',
    dangerSoft: 'rgba(248,113,113,0.10)',
    dangerText: '#fca5a5',
    warning: '#fbbf24',
    warningSoft: 'rgba(251,191,36,0.10)',
    warningText: '#fde68a',
    shadow: '0 1px 2px rgba(0,0,0,0.5), 0 4px 12px rgba(0,0,0,0.3)',
    shadowLg: '0 4px 12px rgba(0,0,0,0.5), 0 16px 40px rgba(0,0,0,0.4)',
    cat: ['#818cf8','#2dd4bf','#fbbf24','#f472b6','#a78bfa','#22d3ee','#a3e635','#f87171'],
  },
};

export const getTokens = (mode) => TOKENS[mode] || TOKENS.light;
